import Splide from "@splidejs/splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";

document.addEventListener("DOMContentLoaded", function () {
  if (document.getElementsByClassName("block-nutshell").length >= 1) {
    var splide = new Splide("#nutshell-slider", {
      type: "slide",
      perPage: 1,
      perMove: 1,
      fixedWidth: "356px",
      gap: "24px",
      rewind: false,
      pagination: false,
      arrows: true,
      trimSpace: false,
      breakpoints: {
        992: {
          fixedWidth: "334px",
        },
        768: {
          fixedWidth: "290px",
        },
      },
    });
    splide.mount();
  }

  if (document.getElementsByClassName("block-clients").length >= 1) {
    var splide = new Splide("#clients-slider", {
      type: "loop",
      perPage: 3,
      perMove: 1,
      gap: "24px",
      rewind: false,
      pagination: false,
      arrows: true,
      start: 1,
      focus: 1,
      autoplay: true,
      breakpoints: {
        992: {
          perPage: 2,
        },
        768: {
          perPage: 1,
        },
      },
    });
    splide.mount();
  }

  if (document.getElementsByClassName("block-opdrachtgevers").length >= 1) {
    var splide = new Splide("#opdrachtgevers-slider", {
      type: "loop",
      autoplay: true,
      interval: 10000,
      perPage: 1,
      perMove: 1,
      // gap: '24px',
      rewind: false,
      pagination: false,
      arrows: true,
      start: 1,
      focus: 1,
    });
    splide.mount();
  }

  if (document.getElementsByClassName("block-images").length >= 1) {
    var splide = new Splide("#images-slider", {
      type: "loop",
      perPage: 4,
      perMove: 1,
      gap: "24px",
      rewind: false,
      pagination: false,
      arrows: false,
      start: 1,
      focus: 1,
      autoScroll: {
        speed: 0.5,
        pauseOnFocus: false,
        pauseOnHover: false,
      },
    });
    splide.mount({ AutoScroll });
  }

  if (document.getElementsByClassName("block-four-columns").length >= 1) {
    var splide = new Splide("#columns-slider", {
      type: "slide",
      perMove: 1,
      gap: "24px",
      rewind: false,
      pagination: false,
      arrows: true,
      start: 1,
      focus: 1,
      perPage: 4,
      breakpoints: {
        1200: {
          perPage: 3,
        },
        992: {
          perPage: 2,
        },
        768: {
          perPage: 1,
        },
      },
    });
    splide.mount();
  }
});
